/* eslint-disable */
export const SET_TOKEN = 'SET_TOKEN'
export const SET_EXPIREAT = 'SET_EXPIREAT'
export const SET_USERNAME = 'SET_USERNAME'
export const SET_GROUP = 'SET_GROUP'
export const SET_ISSEARCHOTHER = 'SET_ISSEARCHOTHER'

// airticket
export const SET_SAVING = 'SET_SAVING'
export const SET_ERROR = 'SET_ERROR'
export const SET_CALCULATE = 'SET_CALCULATE'

// transaction
export const SET_SEARCHING = 'SET_SEARCHING'
export const SET_SUPPLEMENT = 'SET_SUPPLEMENT'
export const SET_REBATE = 'SET_REBATE'
export const SET_REFUND = 'SET_REFUND'

export const SET_CURRENCY = 'SET_CURRENCY'
export const INIT_FORM = 'INIT_FORM'
export const SET_EXCHANGE_RATE = 'SET_EXCHANGE_RATE'

// individual tour
export const SET_SAVING_INDIVIDUAl = 'SET_SAVING_INDIVIDUAl'
export const SET_ERROR_INDIVIDUAl = 'SET_ERROR_INDIVIDUAl'
export const SET_CALCULATE_INDIVIDUAl = 'SET_CALCULATE_INDIVIDUAl'

export const SET_CURRENCY_INDIVIDUAl = 'SET_CURRENCY_INDIVIDUAl'
export const INIT_FORM_INDIVIDUAl = 'INIT_FORM_INDIVIDUAl'
export const SET_EXCHANGE_RATE_INDIVIDUAl = 'SET_EXCHANGE_RATE_INDIVIDUAl'

//group_tour
export const INIT_GROUP_FROM_RELATED = 'INIT_GROUP_FROM_RELATED'


// WEBPACK FOOTER //
// ./src/constants/mutation_types.js